
import { BrowserRouter, HashRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SucursalProvider } from "./utils/sucursalContext";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  const Router = __ROUTER_MODE__ === "hash" ? HashRouter : BrowserRouter;

  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <Router basename={__BASE_PATH__}>
          <SucursalProvider>
            <AppRoutes />
          </SucursalProvider>
        </Router>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
